<template>
	<div class="partner-item" :ref="`box_${id}`" :class="{ 'expanded': isExpanded, 'disabled': partner.disabled }"
		@click.stop="onExpand()">
		<section class="item-controls">
			<article class="item-control" :style="{ 'opacity': canGoBack ? '1' : '0' }">
				<i class="fa fa-arrow-left" @click.stop="onGoBack()"></i>
			</article>
			<article class="item-control control-close">
				<i class="fa fa-close" @click.stop="onCollapse()"></i>
			</article>
		</section>
		<img :src="`/assets/${partner.logo}`" alt="" v-if="canDisplayImage" />
		<div v-else class="loading-single-wrapper">
			<span class="fa fa-spin fa-spinner"></span>
		</div>
		<div class="content" v-if="!partner.disabled">
			<h6>Selecciona {{ displayLabel }}</h6>
			<section class="grade-list" v-show=isShowingGradeList>
				<article class="grade" v-for="grade in grades" :key="grade" @click.stop="onGoForward(grade)">
					{{ grade }} <span class="fa fa-chevron-right"></span>
				</article>
			</section>
			<section class="grade-list classes" v-show=isShowingClassList>
				<article class="class" v-for="clase in filteredClasses" :key=clase.idClass>
					<input @change="onSelectClass(clase)" name="class" type="radio" /> {{ clase.className }}
				</article>
			</section>
			<div class="open-partner-action" v-show=isShowingClassList>
				<form target="_blank" :action="literacyUrl" ref="literacy" method="post"
					enctype="application/x-www-form-urlencoded"></form>
				<button type="button" @click.stop="onOpenPartner()" :disabled=!hasAClassSelected class="btn">
					<span v-if="!loading">Abrir</span>
					<i v-else class="fa fa-spin fa-spinner"></i>
				</button>
			</div>
		</div>
		<vue-toastr ref="toastr" @click.stop="onToastrClicked"></vue-toastr>
	</div>
</template>

<script>
import VueToastr from 'vue-toastr'
import axios from 'axios'
import { SIGNOUT } from '@/vuex/mutations'

export default {
	components: {
		VueToastr
	},
	props: ['partner', 'id'],
	data() {
		return {
			currentListActive: 'class',
			isExpanded: false,
			selectedClass: null,
			selectedGrade: null,
			literacyUrl: '',
			loading: false
		}
	},
	methods: {
		onSelectClass(clase) {
			this.selectedClass = clase;
		},
		onGoBack() {
			if (!this.hasGrades) return;

			this.currentListActive = "grade";
		},
		onGoForward(grade) {
			this.selectedGrade = grade;
			this.currentListActive = "class";
		},
		onCollapse() {
			this.isExpanded = false;
			this.$emit('toggleState', false);
		},
		onExpand() {
			if (this.partner.disabled) return;

			if (!this.hasManyClasses || this.isNotScholastic) { //Open url directly without class selection
				this.selectedClass = this.partner.clase[0];
				this.onOpenPartner();
				return;
			}

			if (this.isExpanded) return;

			if (this.hasGrades) this.currentListActive = "grade";
			else this.currentListActive = "class";

			this.isExpanded = true;
			this.$emit('toggleState', true);
		},
		async onOpenPartner() {
			this.loading = true;

			console.log(this.user);

			switch (this.partner.idAcademicPartner) {

				// Lectura inteligente // BE99DDB6-777D-4A74-A86D-04001436E681
				case "BE99DDB6-777D-4A74-A86D-04001436E681":
					// URL coach going to be fixed for now
					// let url = this.partner.urlCoach;
					let url = `https://www.lecturainteligente.com.mx/asesorv2/index.php?esc=knotion${this.user.idCampusInt}&cmd=login&username=${this.user.userName}&uuid=${this.user.idUser}`
					if (this.user.userType == "Student")
						url = `https://lecturainteligente.com.mx/lector/index.php?esc=knotion${this.user.idCampusInt}&cmd=login&username=${this.user.userName}&id_class=${this.selectedClass.idClassInt}`;
					window.open(url, "_blank");
					break;

				// trueflix // 9F03E6E7-ED73-4377-B13E-186A2E10112C
				// bookflix // 7DF28043-E505-42C6-998B-7055B6450971
				case "9F03E6E7-ED73-4377-B13E-186A2E10112C":
				case "7DF28043-E505-42C6-998B-7055B6450971":
					let lit = await this.getScholasticUrl(this.partner.clase[0].idClass, this.getPartnerIdFromUrl());
					window.open(lit.url, "_blank");
					break;

				// "early bird": cbc688d8-d8ee-11eb-888d-0a310f4549f5
				// "trueflix v2" : cbc686c6-d8ee-11eb-888d-0a310f4549f5
				// "literacy pro" : C2A9C50C-19C9-4881-8537-048B272B78B8
				// "literacy pro library": 9C57AC33-F9AD-4D56-A60A-B529CBA88C80

				case "cbc688d8-d8ee-11eb-888d-0a310f4549f5":
				case "cbc686c6-d8ee-11eb-888d-0a310f4549f5":
				case "C2A9C50C-19C9-4881-8537-048B272B78B8":
				case "9C57AC33-F9AD-4D56-A60A-B529CBA88C80":
					let response = await this.getScholasticUrl(this.selectedClass.idClass, this.getPartnerIdFromUrl());
					this.literacyUrl = response.url + "?" + response.postData;
					setTimeout(() => {
						this.$refs.literacy.submit();
					}, 50);
					break;

				// kn·spire : E09D5D83-9B0F-481E-9E53-10E4709A5F74
				case "E09D5D83-9B0F-481E-9E53-10E4709A5F74":
					let bin = await this.getBinumiUrl();
					if (!bin) {
						this.$refs.toastr.e({
							msg: "No se pudo hacer sign on en Binumi",
							preventDuplicates: true,
							type: "error"
						});
						this.loading = false;
						return;
					}
					else window.open(bin.data.url, "_blank");
					break;

				default:
					window.open(this.url, "_blank");
			}
			this.loading = false;
			this.onCollapse();
		},
		getPartnerIdFromUrl() {
			return this.url.replace("{{", "")
				.replace("}}", "")
				.split(":")[1];
		},
		getScholasticUrl(idClass, idPartner) {
			const headers = {
				"Authorization": `bearer ${this.token}`,
				"Content-Type": "application/json"
			};
			const request = {
				idClass: idClass,
				idAcademicPartner: idPartner
			};
			return axios.post(
				`${process.env.VUE_APP_API_URL}/api-dep/academic-partner/scholastic`,
				request,
				{ headers: headers })
				.then(res => res.data)
				.catch(err => {
					if (err.response.status == 401) {
						this.$store.commit(SIGNOUT)
						this.$router.push("/login");
					} else {
						this.$refs.toastr.e({
							msg: "Ocurrió un error",
							preventDuplicates: true,
							type: "error"
						});
						this.loading = false;
					}
				});
		},
		getBinumiUrl() {
			const headers = {
				"Authorization": `bearer ${this.token}`,
				"Content-Type": "application/json"
			};
			return axios.get(
				`${process.env.VUE_APP_API_URL}/api-dep/binumi/singleSignOn/user/${this.user.auth_key}`,
				{ headers: headers })
				.then(res => res.data)
				.catch(err => {
					if (err.response.status == 401) {
						this.$store.commit(SIGNOUT)
						this.$router.push("/login");
					}
				});
		},
		onToastrClicked() {
			console.log('in');
		}
	},
	computed: {
		canDisplayImage() {
			if (this.isExpanded) return true;

			return !this.loading;
		},
		isNotScholastic() {
			return ["lectura inteligente", "kn·spire", "dreambox", "trueflix", "bookflix"].includes(this.partner.name.toLowerCase());
		},
		user() {
			return this.$store.state.info;
		},
		token() {
			return this.$store.state.token;
		},
		displayLabel() {
			return this.currentListActive == "class" ? "una clase" : "un grado";
		},
		url() {
			return this.user.userType == "Student" ? this.partner.urlStudent : this.partner.urlCoach;
		},
		canGoBack() {
			return this.currentListActive == "class" && this.hasGrades;
		},
		isShowingGradeList() {
			return this.currentListActive == "grade";
		},
		isShowingClassList() {
			return this.currentListActive == "class";
		},
		hasManyClasses() {
			return this.partner.clase.length > 1;
		},
		hasGrades() {
			return this.user.userType == "Student" ? false : (this.grades.length > 1);
		},
		grades() {
			return [...new Set(this.partner.clase.sort((a, b) => {
				return a.idGradeInt > b.idGradeInt ? 1 : (
					a.idGradeInt < b.idGradeInt ? - 1 : 0
				)
			}).map(el => el.gradeName))];
		},
		hasAClassSelected() {
			return !!this.selectedClass;
		},
		filteredClasses() {
			return this.grades.length == 1 ? this.partner.clase :
				this.partner.clase.filter(el => el.gradeName == this.selectedGrade);
		}
	}
}
</script>

<style lang="scss">
$partnerBoxWidth : 350px;
$partnerBoxHeight : 200px;
$partnerBoxCollapsedHeight : 650px;

.partner-item {
	position: relative;
	width: $partnerBoxWidth;
	height: $partnerBoxHeight;
	padding: 45px;
	border-radius: 20px;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
	background-color: #ffffff;
	margin: 40px 30px;
	cursor: pointer;

	.loading-single-wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 40px;
		color: #579adc;

		.fa-spin {
			animation-duration: 1.5s;
		}
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	&.disabled {
		cursor: auto;

		img {
			filter: grayscale(100%);
		}
	}

	.content {
		display: none;
		transition: all 0.5s;
	}

	.item-controls {
		display: none;
	}

	&.expanded {
		height: $partnerBoxCollapsedHeight;
		position: absolute;
		margin-bottom: 0px;
		transition: all .5s ease;

		cursor: default;

		img {
			width: 280px;
			height: 100px;
		}

		.item-controls {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			position: absolute;
			top: 5px;
			left: 0px;
			padding: 0px 15px;

			.item-control {
				font-size: 22px;
				cursor: pointer;

				&.control-close {
					font-size: 24px;
				}
			}
		}

		.content {
			position: relative;
			height: calc(100% - 100px);
			min-height: 350px;
			display: block;
			margin-top: 40px;
			opacity: 0;
			animation: fadeIn 1.5s forwards;

			@keyframes fadeIn {
				0% {
					opacity: 0;
				}

				100% {
					opacity: 1;
				}
			}

			h6 {
				font-weight: bold;
				text-align: center;
			}

			.grade-list {
				height: calc(100% - 80px);
				overflow-y: auto;
				margin-top: 40px;

				.grade {
					margin-top: 20px;
					text-align: center;
					font-size: 20px;
					cursor: pointer;

					.fa {
						margin-left: 20px;
					}
				}

				&.classes {
					min-width: 150px;
					margin: 0 auto;
					margin-top: 40px;
				}

				.class {
					margin: 10px 0px;

					[type='radio'] {
						margin: 0px 10px;
					}
				}
			}

			.open-partner-action {
				width: 100%;
				position: absolute;
				bottom: 10px;
				left: 0px;

				display: flex;
				align-items: center;
				justify-content: center;

				.btn {
					width: 150px;
					background: #579adc;
					color: white;
					border-radius: 26px;
				}
			}
		}
	}
}</style>